import { Stepper } from "@JohnLewisPartnership/jl-design-system/dist/components/stepper/Stepper";
import { CardComponentProps } from "@~/types/types";
import { useProductCardEvent } from "@~/contexts/ProductCardEventContext/ProductCardEventContext.tsx";
import { productCardEvents } from "@~/contexts/ProductCardEventContext/productCardEvents";
import styles from "./QuantityWanted.module.scss";

export function QuantityWanted({
  product,
}: Pick<CardComponentProps, "product">) {
  const dispatchEvent = useProductCardEvent();

  if (product.wanted === undefined) {
    return null;
  }

  const minQuantity = Math.max(product.purchased ?? 0, 1);

  return (
    <div data-component="pcl-QuantityWanted">
      <Stepper
        className={styles.quantityWanted}
        id="stepper"
        labelText="Quantity wanted"
        max={10}
        min={minQuantity}
        name="quantity"
        onChange={(quantity) => {
          dispatchEvent(productCardEvents.quantityWantedUpdate, {
            quantityWanted: quantity,
          });
        }}
        value={product.wanted}
        disabled={product.isRetired || product.isUnlisted}
      />
    </div>
  );
}
